module.exports = __webpack_public_path__ + "static/parkwood-rosebank-225b356e0bde6c883529fcd2c1f5d7cc.jpeg";